/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  LoginIn,
  MessageResponse,
  MfaAnswerIn,
  RedeemLinkIn,
  RequestLinkIn,
  RequestPasswordResetIn,
  ResetPasswordIn,
  SignInOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type loginResponse200 = {
  data: SignInOut
  status: 200
}

export type loginResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type loginResponseSuccess = (loginResponse200) & {
  headers: Headers;
};
export type loginResponseError = (loginResponse422) & {
  headers: Headers;
};

export type loginResponse = (loginResponseSuccess | loginResponseError)

export const getLoginUrl = () => {




  return `/api/auth/login`
}

/**
 * @summary Login
 */
export const login = async (loginIn: LoginIn, options?: Parameters<typeof apiFetch>[1]): Promise<loginResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<loginResponse>(getLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(loginIn)
  }
);}





export const getLoginMutationKey = () => ['login'] as const;

export const getLoginMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,LoginMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,LoginMutationVariables, TContext> => {

const mutationKey = getLoginMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, LoginMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  login(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = LoginIn
    export type LoginMutationError = HTTPValidationError
    export type LoginMutationVariables = {data: LoginIn}

    /**
 * @summary Login
 */
export const useLogin = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,LoginMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        LoginMutationVariables,
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options), queryClient);
    }
    export type answerMfaResponse200 = {
  data: SignInOut
  status: 200
}

export type answerMfaResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type answerMfaResponseSuccess = (answerMfaResponse200) & {
  headers: Headers;
};
export type answerMfaResponseError = (answerMfaResponse422) & {
  headers: Headers;
};

export type answerMfaResponse = (answerMfaResponseSuccess | answerMfaResponseError)

export const getAnswerMfaUrl = () => {




  return `/api/auth/mfa`
}

/**
 * @summary Answer Mfa
 */
export const answerMfa = async (mfaAnswerIn: MfaAnswerIn, options?: Parameters<typeof apiFetch>[1]): Promise<answerMfaResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<answerMfaResponse>(getAnswerMfaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(mfaAnswerIn)
  }
);}





export const getAnswerMfaMutationKey = () => ['answerMfa'] as const;

export const getAnswerMfaMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof answerMfa>>, TError,AnswerMfaMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof answerMfa>>, TError,AnswerMfaMutationVariables, TContext> => {

const mutationKey = getAnswerMfaMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof answerMfa>>, AnswerMfaMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  answerMfa(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AnswerMfaMutationResult = NonNullable<Awaited<ReturnType<typeof answerMfa>>>
    export type AnswerMfaMutationBody = MfaAnswerIn
    export type AnswerMfaMutationError = HTTPValidationError
    export type AnswerMfaMutationVariables = {data: MfaAnswerIn}

    /**
 * @summary Answer Mfa
 */
export const useAnswerMfa = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof answerMfa>>, TError,AnswerMfaMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof answerMfa>>,
        TError,
        AnswerMfaMutationVariables,
        TContext
      > => {
      return useMutation(getAnswerMfaMutationOptions(options), queryClient);
    }
    export type requestLinkResponse200 = {
  data: MessageResponse
  status: 200
}

export type requestLinkResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type requestLinkResponseSuccess = (requestLinkResponse200) & {
  headers: Headers;
};
export type requestLinkResponseError = (requestLinkResponse422) & {
  headers: Headers;
};

export type requestLinkResponse = (requestLinkResponseSuccess | requestLinkResponseError)

export const getRequestLinkUrl = () => {




  return `/api/auth/request-link`
}

/**
 * Same answer and timing for every address. The email goes out after the response.
 * @summary Request Link
 */
export const requestLink = async (requestLinkIn: RequestLinkIn, options?: Parameters<typeof apiFetch>[1]): Promise<requestLinkResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<requestLinkResponse>(getRequestLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(requestLinkIn)
  }
);}





export const getRequestLinkMutationKey = () => ['requestLink'] as const;

export const getRequestLinkMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestLink>>, TError,RequestLinkMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestLink>>, TError,RequestLinkMutationVariables, TContext> => {

const mutationKey = getRequestLinkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestLink>>, RequestLinkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestLinkMutationResult = NonNullable<Awaited<ReturnType<typeof requestLink>>>
    export type RequestLinkMutationBody = RequestLinkIn
    export type RequestLinkMutationError = HTTPValidationError
    export type RequestLinkMutationVariables = {data: RequestLinkIn}

    /**
 * @summary Request Link
 */
export const useRequestLink = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestLink>>, TError,RequestLinkMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestLink>>,
        TError,
        RequestLinkMutationVariables,
        TContext
      > => {
      return useMutation(getRequestLinkMutationOptions(options), queryClient);
    }
    export type redeemLinkResponse200 = {
  data: SignInOut
  status: 200
}

export type redeemLinkResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type redeemLinkResponseSuccess = (redeemLinkResponse200) & {
  headers: Headers;
};
export type redeemLinkResponseError = (redeemLinkResponse422) & {
  headers: Headers;
};

export type redeemLinkResponse = (redeemLinkResponseSuccess | redeemLinkResponseError)

export const getRedeemLinkUrl = () => {




  return `/api/auth/redeem`
}

/**
 * @summary Redeem Link
 */
export const redeemLink = async (redeemLinkIn: RedeemLinkIn, options?: Parameters<typeof apiFetch>[1]): Promise<redeemLinkResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<redeemLinkResponse>(getRedeemLinkUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(redeemLinkIn)
  }
);}





export const getRedeemLinkMutationKey = () => ['redeemLink'] as const;

export const getRedeemLinkMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemLink>>, TError,RedeemLinkMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof redeemLink>>, TError,RedeemLinkMutationVariables, TContext> => {

const mutationKey = getRedeemLinkMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemLink>>, RedeemLinkMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  redeemLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RedeemLinkMutationResult = NonNullable<Awaited<ReturnType<typeof redeemLink>>>
    export type RedeemLinkMutationBody = RedeemLinkIn
    export type RedeemLinkMutationError = HTTPValidationError
    export type RedeemLinkMutationVariables = {data: RedeemLinkIn}

    /**
 * @summary Redeem Link
 */
export const useRedeemLink = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemLink>>, TError,RedeemLinkMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof redeemLink>>,
        TError,
        RedeemLinkMutationVariables,
        TContext
      > => {
      return useMutation(getRedeemLinkMutationOptions(options), queryClient);
    }
    export type requestPasswordResetResponse200 = {
  data: MessageResponse
  status: 200
}

export type requestPasswordResetResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type requestPasswordResetResponseSuccess = (requestPasswordResetResponse200) & {
  headers: Headers;
};
export type requestPasswordResetResponseError = (requestPasswordResetResponse422) & {
  headers: Headers;
};

export type requestPasswordResetResponse = (requestPasswordResetResponseSuccess | requestPasswordResetResponseError)

export const getRequestPasswordResetUrl = () => {




  return `/api/auth/request-password-reset`
}

/**
 * Same answer for every address. The email goes out after the response.
 * @summary Request Password Reset
 */
export const requestPasswordReset = async (requestPasswordResetIn: RequestPasswordResetIn, options?: Parameters<typeof apiFetch>[1]): Promise<requestPasswordResetResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<requestPasswordResetResponse>(getRequestPasswordResetUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(requestPasswordResetIn)
  }
);}





export const getRequestPasswordResetMutationKey = () => ['requestPasswordReset'] as const;

export const getRequestPasswordResetMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError,RequestPasswordResetMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError,RequestPasswordResetMutationVariables, TContext> => {

const mutationKey = getRequestPasswordResetMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestPasswordReset>>, RequestPasswordResetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  requestPasswordReset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof requestPasswordReset>>>
    export type RequestPasswordResetMutationBody = RequestPasswordResetIn
    export type RequestPasswordResetMutationError = HTTPValidationError
    export type RequestPasswordResetMutationVariables = {data: RequestPasswordResetIn}

    /**
 * @summary Request Password Reset
 */
export const useRequestPasswordReset = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestPasswordReset>>, TError,RequestPasswordResetMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof requestPasswordReset>>,
        TError,
        RequestPasswordResetMutationVariables,
        TContext
      > => {
      return useMutation(getRequestPasswordResetMutationOptions(options), queryClient);
    }
    export type resetPasswordResponse200 = {
  data: MessageResponse
  status: 200
}

export type resetPasswordResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type resetPasswordResponseSuccess = (resetPasswordResponse200) & {
  headers: Headers;
};
export type resetPasswordResponseError = (resetPasswordResponse422) & {
  headers: Headers;
};

export type resetPasswordResponse = (resetPasswordResponseSuccess | resetPasswordResponseError)

export const getResetPasswordUrl = () => {




  return `/api/auth/reset-password`
}

/**
 * @summary Reset Password
 */
export const resetPassword = async (resetPasswordIn: ResetPasswordIn, options?: Parameters<typeof apiFetch>[1]): Promise<resetPasswordResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<resetPasswordResponse>(getResetPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resetPasswordIn)
  }
);}





export const getResetPasswordMutationKey = () => ['resetPassword'] as const;

export const getResetPasswordMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,ResetPasswordMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,ResetPasswordMutationVariables, TContext> => {

const mutationKey = getResetPasswordMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, ResetPasswordMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordIn
    export type ResetPasswordMutationError = HTTPValidationError
    export type ResetPasswordMutationVariables = {data: ResetPasswordIn}

    /**
 * @summary Reset Password
 */
export const useResetPassword = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,ResetPasswordMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        ResetPasswordMutationVariables,
        TContext
      > => {
      return useMutation(getResetPasswordMutationOptions(options), queryClient);
    }
    export type logoutResponse204 = {
  data: void
  status: 204
}

export type logoutResponseSuccess = (logoutResponse204) & {
  headers: Headers;
};
;

export type logoutResponse = (logoutResponseSuccess)

export const getLogoutUrl = () => {




  return `/api/auth/logout`
}

/**
 * @summary Logout
 */
export const logout = async ( options?: Parameters<typeof apiFetch>[1]): Promise<logoutResponse> => {

  return apiFetch<logoutResponse>(getLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLogoutMutationKey = () => ['logout'] as const;

export const getLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext> => {

const mutationKey = getLogoutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logout>>, void> = () => {


          return  logout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LogoutMutationResult = NonNullable<Awaited<ReturnType<typeof logout>>>

    export type LogoutMutationError = unknown


    /**
 * @summary Logout
 */
export const useLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logout>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof logout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLogoutMutationOptions(options), queryClient);
    }
